
import { defineComponent } from 'vue';
import HeaderComponent from '../components/Header/HeaderComp.vue'
import OverheaderComponent from '../components/Overheader/OverheaderComp.vue';
import SidebarComponent from '../components/Sidebar/SidebarComp.vue';
import FooterComponent from '../components/Footer/FooterComp.vue';
import MobileNavComp from '../components/Mobile-nav/MobileNavComp.vue';
import ScrollTopButtonComponent from '@/components/Scroll-top-button/ScrollTopButtonComp.vue';

export default defineComponent({
  name: 'HomeView',
  components: {
      HeaderComponent,
      OverheaderComponent,
      SidebarComponent,
      FooterComponent,
      MobileNavComp,
      ScrollTopButtonComponent
  },
});
